import { Box, Grid, Typography } from '@mui/material'
import FormCurriculumElements from './FormCurriculumElements'
import Skeleton from '@mui/material/Skeleton'
import Alert from '@mui/material/Alert'
import { useSelector } from 'react-redux'
import SelectField from '../../../../FormControl/input/SelectField'
import { useParams } from 'react-router-dom'
const FormCurriculum = ({
  onChangeAlert,
  isPreview,
  isLoading,
  errors,
  formData,
  form,
  onChange,
  showHeader = true
}) => {
  const curriculumList = useSelector((state) => state?.assessment?.curriculum)
  const { curriculumId } = useParams()
  const permission = useSelector(
    (state) => state?.session?.permissions?.subject.updated?.includes('curriculum-elements') || false
  )

  return (
    <>
      {showHeader && (
        <Grid item md={12}>
          <Box className='px-4 py-2 bg-primary text-primary-foreground'>
            <Typography variant='inherit' className='font-bold capitalize' component='p'>
              Curriculum Elements
            </Typography>
          </Box>
        </Grid>
      )}
      {errors?.curriculumElements && (
        <Grid item md={12}>
          <Alert severity='error'>{errors?.curriculumElements}</Alert>
        </Grid>
      )}
      <Grid item md={2} sm={3}>
        <Typography
          variant='inherit'
          className='font-bold capitalize'
          color='primary'
          align='right'
          component='p'
        >
          Curriculum
        </Typography>
      </Grid>
      <Grid item md={9} sm={8}>
        {!['unassigned', 'assigned', 'all'].includes(curriculumId) ? (
          <Typography variant='inherit' component='p'>
            {curriculumList?.find((item) => curriculumId === item._id)?.name}
          </Typography>
        ) : isPreview ? (
          <Typography variant='inherit' component='p'>
            {isLoading ? (
              <Skeleton />
            ) : (
              curriculumList?.find((item) => form?.curriculumId === item._id)?.name || '-'
            )}
          </Typography>
        ) : permission ? (
          <SelectField
            id='curriculumId'
            name='curriculumId'
            error={errors?.curriculumId}
            helperText={errors?.curriculumId}
            value={form?.curriculumId}
            onChange={(e) => onChange('curriculumId', e.target.value)}
            placeholder={'Choose a curriculum'}
            options={
              curriculumList.map((item) => ({
                value: item._id,
                label: `${item.shortName} - ${item.name}`
              })) || []
            }
          />
        ) : (
          <Typography variant='inherit' component='p'>
            {curriculumList?.find((item) => form?.curriculumId === item._id)?.name}
          </Typography>
        )}
      </Grid>
      {isLoading ? (
        <Skeleton variant='rectangular' height={100} />
      ) : (
        <FormCurriculumElements
          onChangeAlert={onChangeAlert}
          currentCurriculum={curriculumList?.find((item) => form?.curriculumId === item._id)}
          isPreview={isPreview}
          formData={formData?.curriculumelements || {}}
          errors={errors}
          permission={permission}
        />
      )}
    </>
  )
}

export default FormCurriculum
